import { endOfMonth as fnsEndOfMonth, formatISO } from 'date-fns'
import { parseDate } from '../parseDate'

export const endOfMonth = (dateStr: string): string => {
  const parsedDate = parseDate(dateStr)
  if (!parsedDate) {
    throw new Error('Invalid date string')
  }
  return formatISO(fnsEndOfMonth(parsedDate))
}
